import React from "react";
import "./EntrepriseCard.scss";
import PropTypes from "prop-types";
import { FaSuitcase, FaUsers } from "react-icons/fa";
import "primeicons/primeicons.css";
import { FaHeart } from "react-icons/fa";
import axios from "axios";
import { connect } from "react-redux";
import { updateCompanies } from "Redux/Actions/companiesAction";
import { Link } from "react-router-dom";

const EntrepriseCard = (props) => {
    const changePartnerStatus = () => {
        const url = `${process.env.REACT_APP_BASE_URL_API}/companies/${props.companyId}`;
        axios
            .put(
                url,
                { isPartner: !props.isPartner },
                {
                    headers: props.auth.token
                        ? {
                            accept: "application/json",
                            Authorization: `Bearer ${props.auth.token}`,
                        }
                        : {
                            accept: "application/json",
                        },
                }
            )
            .then((res) => {
                props.handleUpdateCompanies({
                    companiesData: props.companies.companiesData.map((company) => {
                        if (company.id === res.data.id) return res.data;
                        else {
                            return company;
                        }
                    }),
                });
                if (res.data.isPartner) {
                    props.uploadToast.current.show({
                        severity: "success",
                        summary: "Succès : ",
                        detail:
                            "L'entreprise a bien été ajoutée aux entreprises partenaires",
                        life: 3000,
                    });
                } else {
                    props.cancelToast.current.show({
                        severity: "error",
                        summary: "Suppression : ",
                        detail:
                            "L'entreprise a bien été retirée des entreprises partenaires",
                        life: 3000,
                    });
                }
            })
            .catch((error) => console.log(error.message));
    };
    return (
        <div className="entreprises_cards">
            <Link
                to={{
                    pathname: `/annuaire/detail/${props.companyId}`,
                }}
                key={props.companyId}
            >
                <div className="entreprises_cards__top">
                    <img
                        src={require(`../../../assets/${props.imageFond}.webp`)}
                        alt="Fond d'entreprise"
                    />
                    <div className="entreprises_cards__top__logo">
                        <img
                            src={require(`../../../assets/logoOffre1.webp`)}
                            alt="Logo d'entreprise"
                        />
                    </div>
                </div>
                <div className="entreprises_cards__corps">
                    <h3>{props.nomEntreprise}</h3>
                    <p>
                        <i className="pi pi-building"></i>
                        {props.type}
                    </p>
                    <p>
                        <FaUsers />
                        {props.taille}
                    </p>
                </div>
            </Link>

            <div className="entreprises_cards__bottom">
                {props.offresDisponibles && (
                    <button className="btn_card">
                        <FaSuitcase /> Voir les offres disponibles
                    </button>
                )}
                <FaHeart
                    className={
                        props.isPartner
                            ? "partner_company_heart"
                            : "not_partner_company_heart"
                    }
                    onClick={() => {
                        props.fromGestion && changePartnerStatus();
                    }}
                ></FaHeart>
            </div>
        </div>
    );
};

EntrepriseCard.propTypes = {
    nomEntreprise: PropTypes.string,
    type: PropTypes.string,
    taille: PropTypes.string,
    imageLogo: PropTypes.string,
    imageFond: PropTypes.string,
    offresDisponibles: PropTypes.bool,
    isPartner: PropTypes.bool,
    companyId: PropTypes.number,
    handleUpdateCompanies: PropTypes.func,
    companies: PropTypes.object,
    auth: PropTypes.object,
    uploadToast: PropTypes.any,
    cancelToast: PropTypes.any,
    fromGestion: PropTypes.bool,
};

const mapStateToProps = (state) => ({
    companies: state.companies,
    auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
    handleUpdateCompanies: (value) => {
        dispatch(updateCompanies(value));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(EntrepriseCard);
